import { render, staticRenderFns } from "./LabelContractsGroupDialog.vue?vue&type=template&id=587d43a2"
import script from "./LabelContractsGroupDialog.vue?vue&type=script&lang=js"
export * from "./LabelContractsGroupDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports